import { Link as RouterLink } from "react-router-dom"

type Props = {
  to: string
  label?: string
  children?: React.ReactNode
  isDisabled?: boolean
}

export const Link: React.FC<Props> = ({ to, label, children, isDisabled }) => {
  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    if (isDisabled) event.preventDefault()
  }

  return (
    <RouterLink
      to={to}
      style={{ cursor: isDisabled ? "not-allowed" : "pointer" }}
      onClick={handleClick}
    >
      {label ? label : children}
    </RouterLink>
  )
}
